<script setup lang="ts">
import type { Art } from "@/model/session";

defineProps<{ arts: Art[] }>();
</script>

<template>
  {{ $t("general.arts") }}
  <div v-for="art in arts" :key="art.id" class="shortcut">
    {{ art.name }}
  </div>
</template>
